module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_28.44d44172.png";